import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { CTASection } from '../components/CTASection';
import { Plus, Minus } from 'lucide-react';
interface FAQPageProps {
  onNavigate: (page: string) => void;
}
export function FAQPage({
  onNavigate
}: FAQPageProps) {
  const [openIndex, setOpenIndex] = useState<string | null>(null);
  const toggleFAQ = (id: string) => {
    setOpenIndex(openIndex === id ? null : id);
  };
  const faqs = [{
    category: 'Allgemein & App',
    questions: [{
      id: 'q1',
      q: 'Ist die SmartProtect24 App wirklich kostenlos?',
      a: 'Ja, die Nutzung der App und aller Vergleichsrechner ist für Sie zu 100% kostenlos. Wir finanzieren uns durch Provisionen der Versicherer bei Abschluss, ohne dass für Sie Mehrkosten entstehen.'
    }, {
      id: 'q2',
      q: 'Wie sicher sind meine Daten?',
      a: 'Wir nutzen Bank-Level Verschlüsselung (AES-256) und hosten alle Daten auf zertifizierten deutschen Servern. Datenschutz hat bei uns höchste Priorität.'
    }]
  }, {
    category: 'Versicherungen & Abschluss',
    questions: [{
      id: 'q3',
      q: 'Kann ich meine bestehenden Versicherungen importieren?',
      a: 'Ja, Sie können bestehende Verträge einfach per Foto oder PDF-Upload in die App laden. Wir digitalisieren Ihren Ordner automatisch.'
    }, {
      id: 'q4',
      q: 'Wie funktioniert der Wechsel?',
      a: 'Mit wenigen Klicks können Sie alte Verträge kündigen und neue abschließen. Wir übernehmen den kompletten Papierkram für Sie.'
    }, {
      id: 'q5',
      q: 'Bin ich an Laufzeiten gebunden?',
      a: 'Das hängt vom jeweiligen Versicherungsvertrag ab. Die Nutzung unserer Plattform selbst ist jederzeit kündbar.'
    }]
  }, {
    category: 'Beratung & Service',
    questions: [{
      id: 'q6',
      q: 'Ist die Beratung unabhängig?',
      a: 'Ja, wir sind als unabhängiger Makler tätig und nicht an bestimmte Gesellschaften gebunden. Wir vertreten Ihre Interessen.'
    }, {
      id: 'q7',
      q: 'Wie erreiche ich den Support?',
      a: 'Sie erreichen unseren Premium-Support per Chat in der App, per E-Mail oder telefonisch Mo-Fr von 9-18 Uhr.'
    }]
  }];
  return <div className="min-h-screen bg-slate-50" data-id="element-397">
      <div className="bg-white py-20 border-b border-slate-200" data-id="element-398">
        <div className="container mx-auto px-4 text-center" data-id="element-399">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-400">
            Häufig gestellte Fragen
          </h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed" data-id="element-401">
            Hier finden Sie Antworten auf die wichtigsten Fragen rund um
            SmartProtect24.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-20 max-w-4xl" data-id="element-402">
        <div className="space-y-16" data-id="element-403">
          {faqs.map((section, idx) => <div key={idx} data-id="element-404">
              <h2 className="text-2xl font-bold text-slate-900 mb-8 flex items-center gap-3" data-id="element-405">
                <div className="h-2 w-2 bg-blue-600 rounded-full" data-id="element-406"></div>
                {section.category}
              </h2>
              <div className="space-y-4" data-id="element-407">
                {section.questions.map(item => <Card key={item.id} className={`overflow-hidden cursor-pointer transition-all duration-300 border-slate-200 hover:border-blue-300 ${openIndex === item.id ? 'shadow-md ring-1 ring-blue-100' : 'shadow-sm'}`} onClick={() => toggleFAQ(item.id)} data-id="element-408">
                    <CardHeader className="bg-white py-5 px-6 flex flex-row items-center justify-between space-y-0" data-id="element-409">
                      <CardTitle className="text-lg text-slate-900 font-semibold pr-8" data-id="element-410">
                        {item.q}
                      </CardTitle>
                      {openIndex === item.id ? <Minus className="h-5 w-5 text-blue-600 flex-shrink-0" data-id="element-411" /> : <Plus className="h-5 w-5 text-slate-400 flex-shrink-0" data-id="element-412" />}
                    </CardHeader>
                    {openIndex === item.id && <CardContent className="pt-0 pb-6 px-6 text-slate-600 leading-relaxed animate-in slide-in-from-top-2 duration-200" data-id="element-413">
                        {item.a}
                      </CardContent>}
                  </Card>)}
              </div>
            </div>)}
        </div>
      </div>

      <CTASection title="Noch Fragen offen?" description="Unser Support-Team hilft Ihnen gerne weiter." primaryCtaText="Kontakt aufnehmen" onPrimaryClick={() => onNavigate('kontakt')} data-id="element-414" />
    </div>;
}